// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthenticateRoute = ({ children }) => {
  const token = localStorage.getItem('token'); // Assuming the token is stored as 'authToken'

  // If there's no token, redirect to the admin login page
  if (!token) {
    return <Navigate to="/admin" />;
  }

  // If token exists, render the requested admin page
  return children;
};

export default AuthenticateRoute;
